import type { IconSvgObject } from './types';

const RatioIcon: IconSvgObject = [
  ["path", { d: "M6 20V4C6 2.89543 6.89543 2 8 2H16C17.1046 2 18 2.89543 18 4V20C18 21.1046 17.1046 22 16 22H8C6.89543 22 6 21.1046 6 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 6L20 6C21.1046 6 22 6.89543 22 8V16C22 17.1046 21.1046 18 20 18L4 18C2.89543 18 2 17.1046 2 16L2 8C2 6.89543 2.89543 6 4 6Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RatioIcon;
